<script setup>
import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css"
import {onMounted} from "vue";


onMounted(() => {
  console.log('hello')
  const ui = SwaggerUI({
    url: "/main.yaml",
    dom_id: '#swagger-ui',
    // layout: "StandaloneLayout",
  })

  window.swaggerUi.api.apis[key].basePath = "http://target:port";
})
</script>

<template>
  <main>
    <div id="swagger-ui"></div>
  </main>
</template>
